import { RSAA, getJSON } from 'redux-api-middleware';
import { EventViewModel } from 'stageclip-common';

import { normalizeEventsArray, normalizeEvent } from 'api/normalizers/eventNormalizers';
import { InternalActionTypes } from 'constants/actionTypes';
import { SendVideoReminderBody, UnlockParticipantClipBody, ResetParticipantRenderBody } from './events.types';

const FETCH_EVENTS_REQUEST = 'FETCH_EVENTS_REQUEST';
const FETCH_EVENTS_FAILURE = 'FETCH_EVENTS_FAILURE';

export const fetchEvents = (archived = false) => ({
  [RSAA]: {
    types: [
      FETCH_EVENTS_REQUEST,
      {
        type: archived ? InternalActionTypes.ArchivedEventsLoaded : InternalActionTypes.ActiveEventsLoaded,
        payload: (action: any, state: any, res: any) =>
          // @ts-ignore
          getJSON(res).then((json: any) => normalizeEventsArray(json)),
        meta: {
          unwrapPayload: true,
        },
      },
      FETCH_EVENTS_FAILURE,
    ],
    endpoint: `/events?archived=${archived}`,
    method: 'GET',
  },
});

const FETCH_MONITORING_EVENTS_REQUEST = 'FETCH_MONITORING_EVENTS_REQUEST';
const FETCH_MONITORING_EVENTS_SUCCESS = 'FETCH_MONITORING_EVENTS_SUCCESS';
const FETCH_MONITORING_EVENTS_FAILURE = 'FETCH_MONITORING_EVENTS_FAILURE';

export const fetchMonitoringEvents = (archived = false, active = false) => ({
  [RSAA]: {
    types: [FETCH_MONITORING_EVENTS_REQUEST, FETCH_MONITORING_EVENTS_SUCCESS, FETCH_MONITORING_EVENTS_FAILURE],
    endpoint: `/events?archived=${archived}&active=${active}`,
    method: 'GET',
  },
});

const SEND_VIDEO_REMINDER_REQUEST = 'SEND_VIDEO_REMINDER_REQUEST';
const SEND_VIDEO_REMINDER_SUCCESS = InternalActionTypes.VideoReminderEmailSent;
const SEND_VIDEO_REMINDER_FAILURE = 'SEND_VIDEO_REMINDER_FAILURE';

export const sendVideoReminder = (eventId: string, body: SendVideoReminderBody) => ({
  [RSAA]: {
    types: [
      SEND_VIDEO_REMINDER_REQUEST,
      {
        type: SEND_VIDEO_REMINDER_SUCCESS,
        payload: (action: any, state: any, res: any) =>
          // @ts-ignore
          getJSON(res).then((json: any) => normalizeEvent(json)),
        meta: {
          unwrapPayload: true,
        },
      },
      SEND_VIDEO_REMINDER_FAILURE,
    ],
    endpoint: `/events/${eventId}`,
    method: 'PATCH',
    body,
  },
});

const ARCHIVE_EVENT_REQUEST = 'ARCHIVE_EVENT_REQUEST';
const ARCHIVE_EVENT_FAILURE = 'ARCHIVE_EVENT_FAILURE';

export const createArchiveEvent = ({ id, ...body }: Partial<EventViewModel>) => ({
  [RSAA]: {
    types: [
      ARCHIVE_EVENT_REQUEST,
      {
        type: body.archived ? InternalActionTypes.EventArchived : InternalActionTypes.EventUnarchived,
        payload: (action: any, state: any, res: any) =>
          // @ts-ignore
          getJSON(res).then((json: any) => normalizeEvent(json)),
        meta: {
          unwrapPayload: true,
        },
      },
      ARCHIVE_EVENT_FAILURE,
    ],
    endpoint: `/events/${id}`,
    method: 'PATCH',
    body,
  },
});

const CANCEL_EVENT_REQUEST = 'CANCEL_EVENT_REQUEST';
const CANCEL_EVENT_SUCCESS = InternalActionTypes.EventCancelled;
const CANCEL_EVENT_FAILURE = 'CANCEL_EVENT_FAILURE';

export const cancelEvent = ({ id, ...body }: any) => ({
  [RSAA]: {
    types: [
      CANCEL_EVENT_REQUEST,
      {
        type: CANCEL_EVENT_SUCCESS,
        payload: (action: any, state: any, res: any) =>
          // @ts-ignore
          getJSON(res).then((json: any) => normalizeEvent(json)),
        meta: {
          unwrapPayload: true,
        },
      },
      CANCEL_EVENT_FAILURE,
    ],
    endpoint: `/events/${id}`,
    method: 'PATCH',
    body,
  },
});

const UNLOCK_TEMPLATE_REQUEST = 'UNLOCK_TEMPLATE_REQUEST';
const UNLOCK_TEMPLATE_SUCCESS = InternalActionTypes.UnlockTemplate;
const UNLOCK_TEMPLATE_FAILURE = 'UNLOCK_TEMPLATE_FAILURE';

export const unlockTemplate = ({ id }: any) => ({
  [RSAA]: {
    types: [
      UNLOCK_TEMPLATE_REQUEST,
      {
        type: UNLOCK_TEMPLATE_SUCCESS,
        payload: (action: any, state: any, res: any) =>
          // @ts-ignore
          getJSON(res).then((json: any) => normalizeEvent(json)),
        meta: {
          unwrapPayload: true,
        },
      },
      UNLOCK_TEMPLATE_FAILURE,
    ],
    endpoint: `/events/${id}/unlock-template`,
    method: 'PUT',
  },
});

const UNLOCK_PARTICIPANT_CLIP_REQUEST = 'UNLOCK_PARTICIPANT_CLIP_REQUEST';
const UNLOCK_PARTICIPANT_CLIP_SUCCESS = InternalActionTypes.UnlockClip;
const UNLOCK_PARTICIPANT_CLIP_FAILURE = 'UNLOCK_PARTICIPANT_CLIP_FAILURE';

export const unlockParticipantClip = (eventId: string, body: UnlockParticipantClipBody) => ({
  [RSAA]: {
    types: [
      UNLOCK_PARTICIPANT_CLIP_REQUEST,
      {
        type: UNLOCK_PARTICIPANT_CLIP_SUCCESS,
        payload: (action: any, state: any, res: any) =>
          // @ts-ignore
          getJSON(res).then((json: any) => normalizeEvent(json)),
        meta: {
          unwrapPayload: true,
        },
      },
      UNLOCK_PARTICIPANT_CLIP_FAILURE,
    ],
    endpoint: `/events/${eventId}/unlock-clip`,
    method: 'POST',
    body,
  },
});

const RESET_PARTICIPANT_RENDER_REQUEST = 'RESET_PARTICIPANT_RENDER_REQUEST';
const RESET_PARTICIPANT_RENDER_SUCCESS = InternalActionTypes.ResetRender;
const RESET_PARTICIPANT_RENDER_FAILURE = 'RESET_PARTICIPANT_RENDER_FAILURE';

export const resetParticipantRender = (eventId: string, body: ResetParticipantRenderBody) => ({
  [RSAA]: {
    types: [
      RESET_PARTICIPANT_RENDER_REQUEST,
      {
        type: RESET_PARTICIPANT_RENDER_SUCCESS,
        payload: (action: any, state: any, res: any) =>
          // @ts-ignore
          getJSON(res).then((json: any) => normalizeEvent(json)),
        meta: {
          unwrapPayload: true,
        },
      },
      RESET_PARTICIPANT_RENDER_FAILURE,
    ],
    endpoint: `/events/${eventId}/participants/${body.participantId}/reset-render`,
    method: 'POST',
  },
});
